import { AxiosResponse } from 'axios';
import BaseAPI from "../api";

const path: string = "/class-room";

export type listType = {
  degree?: string;
  faculty?: string;
  date_of_issue?: string;
  year_graduated?: string;
  status?: string;
  created_id?: string;
  created_date?: string;
  modified_id?: string;
  modified_date?: number;
  type?: string;
  limit?: number;
  page?: number;
  keyword?: string;
  search?: string;
  year_education?: string;
  id_degree?: number;
  id_faculty?: number;
  room?: number;
  sortType?: string;
  sortBy?: string;
};

export class classRoomApi extends BaseAPI {
  static getAllClassRoom(query?: listType): Promise<AxiosResponse> {
    return this.api.get(`${path}`, {
      params: { ...query },
    });
  }

  static getClassRoomById(id: number): Promise<any> {
    return this.api.get(`${path}/${id}`);
  }

  static createClassRoom(body: any): Promise<any> {
    return this.api.post(`${path}`, body);
  }

  static updateClassRoom(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/${id}`, body);
  }

  static deleteClassRoom(id: number): Promise<any> {
    return this.api.delete(`${path}/${id}`);
  }

  static getClassRoomOption(): Promise<any> {
    return this.api.get(`${path}/get-rooms`);
  }
}
